import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';

import config, { Config } from '@/utils/config';
import mergeDeep from '@/utils/mergeDeep';
import { EVENTS_HANDLER_FUNCTION } from '@/types/events';
import * as EVENTS from '@/constants/events';

import '@/assets/styles/main.scss';
import '@/assets/styles/antd/index.less';
import '@perxis/perxis-auto-ui-kit/lib/main.css';

if (process.env.NODE_ENV === 'development') {
  import('@/assets/styles/_fonts.scss');
}

export default class App {
  private readonly initConfig: Config;

  private readonly eventsHandler?: EVENTS_HANDLER_FUNCTION;

  private eventListener?: EventListener;

  private root?: ReactDOM.Root;

  static Events = { ...EVENTS };

  constructor(initConfig: Config, eventsHandler?: EVENTS_HANDLER_FUNCTION) {
    this.initConfig = initConfig;
    this.eventsHandler = eventsHandler;

    const defaultConfig = require(`./apps/${ENV.widget}/defaultConfig`).default;

    const resolvedWidgetConfig: Config = mergeDeep(
      {
        selectorId: ENV.selectorId,
        widget: ENV.widget,
      },
      defaultConfig,
      this.initConfig,
    );

    config.set(resolvedWidgetConfig);

    if (this.eventsHandler) {
      const { EVENTS_CHANNEL } = require(`./apps/${ENV.widget}/constants/events`);

      this.eventListener = this.dispatchEvent.bind(this) as EventListener;

      document.addEventListener(EVENTS_CHANNEL, this.eventListener);
    }
  }

  dispatchEvent(e: CustomEvent) {
    if (!this.eventsHandler) {
      return;
    }
    const { type } = e.detail;
    const eventData = e.detail;

    this.eventsHandler(type, eventData);
  }

  removeEventListener() {
    if (this.eventListener) {
      const { EVENTS_CHANNEL } = require(`./apps/${ENV.widget}/constants/events`);

      document.removeEventListener(EVENTS_CHANNEL, this.eventListener);

      this.eventListener = undefined;
    }
  }

  inspect() {
    return {
      version: ENV.version,
      buildEnvironment: ENV.buildEnvironment,
      buildDate: ENV.buildDate,
      webpackParams: ENV.webpackParams,
      appConfig: config.getFullConfig(),
    };
  }

  render() {
    const rootElement = document.getElementById(config.get('selectorId'));

    if (!rootElement) {
      throw new Error(`Не найден элемент ${config.get('selectorId')}`);
    }

    const FormWidget = require(`./apps/${ENV.widget}/`).default;

    this.root = createRoot(rootElement);

    this.root.render(
      <div className="omoda-form-widget">
        <FormWidget />
      </div>,
    );
  }

  unmount() {
    if (this.root) {
      this.root.unmount();
      this.root = undefined;
    }
    this.removeEventListener();
  }

  init() {
    this.render();
  }
}
